module.exports = __webpack_public_path__ + "static/img/noImg.4e85045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/works/noImg.png
// module id = 8ioy
// module chunks = 1